import MojitoCore from 'mojito/core';
import SegmentBasedInplayScoreboard from 'presentation/components/scoreboard/segment-based-inplay-scoreboard/index.js';
import * as utils from '../utils.js';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class CricketScoreboard extends UIViewImplementation {
    getTotalScoreString() {
        const { sportId } = this.props.event;
        const systemSettings = this.appContext().systemSettings();
        return utils.getTotalScoreString(sportId, systemSettings, this.l10n);
    }

    getOvers() {
        const { event } = this.props;
        const { detailedScores } = event.details;

        const firstTeamPosition = event.homeAway ? 'home' : 'away';
        // If true, overs in first inning is for home team
        let overIndex = parseInt(detailedScores[0][firstTeamPosition], 10) !== 0 ? 0 : 1;

        // [home, away]
        const oversScores = new Array(2).fill(0.0);

        // Iterate innings and set largest overs for each team
        detailedScores.forEach(score => {
            if (parseFloat(oversScores[overIndex]) < parseFloat(score.overs)) {
                oversScores[overIndex] = score.overs;
            }
            overIndex = (overIndex + 1) % 2;
        });

        return {
            scores: oversScores,
            header: this.resolveString('$CRICKET_SCOREBOARD.OVERS_INFO_HEADER'),
        };
    }

    getSegments() {
        const { event } = this.props;
        const { detailedScores, inplayDescription } = event.details;
        const headers = [
            this.resolveString('$CRICKET_SCOREBOARD.INNINGS.FIRST'),
            this.resolveString('$CRICKET_SCOREBOARD.INNINGS.SECOND'),
        ];

        return detailedScores.map(({ home, away, id: period }, idx) => {
            return {
                scores: event.homeAway ? [home, away] : [away, home],
                header: headers[idx],
                selected: period === inplayDescription,
            };
        });
    }

    getParticipantsData() {
        const { event } = this.props;
        const participantInfos = utils.getDetailedParticipantsData(event, 'totalScores');

        return participantInfos.map(participantInfo => {
            const { score, position } = participantInfo;
            const wicketSegment = utils.getWicket(event, position);
            const wicket = parseInt(wicketSegment, 10) > 0;
            return {
                ...participantInfo,
                score: wicket ? score.concat(`/${wicketSegment}`) : score,
            };
        });
    }

    shouldShowSeveralInnings() {
        const { maxSegments, detailedScores } = this.props.event.details;
        return maxSegments === 4 || detailedScores.length === 2;
    }

    render() {
        const { event } = this.props;

        if (!event?.details?.detailedScores?.length) {
            return null;
        }

        const scoreboardProps = {
            event,
            hasServer: !!event.details.server && this.shouldShowSeveralInnings(),
            config: { ...this.config.segmentBasedInplayScoreboard, style: this.style },
            detailedParticipantsData: this.getParticipantsData(),
            inplayTime: this.props.inplayTime,
            hasClockDetails: this.props.hasClockDetails,
        };

        if (this.shouldShowSeveralInnings()) {
            scoreboardProps.showTotalScore = false;
            scoreboardProps.detailedSegments = this.getSegments();
        } else {
            scoreboardProps.detailedSegments = [this.getOvers()];
            scoreboardProps.displayStrings = { totalScore: this.getTotalScoreString() };
        }

        return <SegmentBasedInplayScoreboard {...scoreboardProps} />;
    }
}

CricketScoreboard.getStyle = function (config, applicationMode, merge) {
    const { accentColor } = config.segmentBasedInplayScoreboard;

    const styles = merge(config.segmentBasedInplayScoreboard.style, {
        currentSegmentDataCell: { color: accentColor },
    });

    return styles;
};
